import { LatLng, LatLngBounds } from 'leaflet';
import { Place } from '../../models/Place';
import { useEffect, useMemo } from 'react';
import { AONB_Bounds } from '../../application/config';
import { useMap, useMapEvents } from 'react-leaflet';

type MapControllerProps = {
	places: Place[];
	autoFitBounds?: boolean;
	setShowToasts: React.Dispatch<React.SetStateAction<any>>;
};

const cloneAONBBounds = () =>
	new LatLngBounds(AONB_Bounds.getSouthWest(), AONB_Bounds.getNorthEast());

const calcBoundary = (pointList: LatLng[]) => {
	if (pointList.length === 0) {
		return cloneAONBBounds();
	}
	if (pointList.length === 1) {
		const boundary = cloneAONBBounds();
		boundary.extend(pointList[0]);
		return boundary;
	}

	const boundary = cloneAONBBounds();
	for (let listNdx = 0; listNdx < pointList.length; listNdx++) {
		boundary.extend(pointList[listNdx]);
	}
	return boundary;
};

export default function MapController({
	places,
	autoFitBounds = true,
	setShowToasts,
}: MapControllerProps) {
	const map = useMap();
	const placePoints = useMemo(
		() =>
			places.map(
				(place) => new LatLng(place.location.lat, place.location.lng),
			),
		[places],
	);

	useMapEvents({
		click: (e) => {
			console.log('Map Click');
			setShowToasts(false);
		},
	});

	useEffect(() => {
		if (!autoFitBounds) {
			return;
		}

		const fitToPlaces = () => {
			const boundary = calcBoundary(placePoints);
			if (!boundary.isValid()) {
				return;
			}
			map.invalidateSize();
			map.fitBounds(boundary, {
				padding: [24, 24],
				maxZoom: 15,
			});
		};

		fitToPlaces();
		const timeoutId = window.setTimeout(fitToPlaces, 150);

		return () => {
			window.clearTimeout(timeoutId);
		};
	}, [autoFitBounds, map, placePoints]);

	return null;
}
